/**
 * 将数值四舍五入到指定的精度
 */
export function round(value, precision) {
  return value ? parseFloat(Number(value).toFixed(precision)) : 0
}

/** 加法 */
export function add(a, b, precision) {
  return round(Number(a || 0) + Number(b || 0), precision)
}

/** 减法 */
export function subtract(a, b, precision) {
  return round(Number(a || 0) - Number(b || 0), precision)
}

/** 乘法 */
export function multiply(a, b, precision) {
  return round(Number(a || 0) * Number(b || 0), precision)
}

/** 除法 */
export function divide(a, b, precision) {
  if (b === 0 || b === undefined || b === null) return 0
  return round(Number(a || 0) / Number(b), precision)
}
